import { render, staticRenderFns } from "./ChatEscalationReview.vue?vue&type=template&id=d1b02212&"
import script from "./ChatEscalationReview.vue?vue&type=script&lang=ts&"
export * from "./ChatEscalationReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports